import React from 'react';
import Header from '../components/header'; 
import Footer from '../components/footer'; 
import MyGallery from '../components/MyGallery';
import FloatingSocial from '../components/floating_social';  

const Gallery = () => {
  return (
    <div>
        <Header />

	<div className="section big-55-height over-hide z-bigger">
	
		<div className="parallax parallax-top" style={{ backgroundImage: `url('/img/35.jpeg')` }}></div>
		<div className="dark-over-pages"></div>
	
		<div className="hero-center-section pages">
			<div className="container">
				<div className="row justify-content-center">
					<div className="col-12 parallax-fade-top">
						<div className="hero-text">Gallery</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	
  <div className="container py-4">
    <div className="row" data-masonry='{"percentPosition": true }'>
 		 
       <MyGallery />
       

    </div>
</div>

     
    <p><br></br><br></br></p>
    <Footer />
	<FloatingSocial />
    </div>
  )
}

export default Gallery;